/**
 * Utility functions for extracting contact information from text
 */

/**
 * Extract email address from a string
 * 
 * @param text String that may contain an email address
 * @returns The first email address found or null if none found
 */
export const extractEmail = (text?: any): string | null => {
  // Check if text is a string before applying regex
  if (!text || typeof text !== 'string') return null;
  
  const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi;
  const match = text.match(emailRegex);
  return match ? match[0] : null;
};

/**
 * Extract phone number from a string
 * 
 * @param text String that may contain a phone number
 * @returns The first phone number found or null if none found
 */
export const extractPhone = (text?: any): string | null => {
  // Check if text is a string before applying regex
  if (!text || typeof text !== 'string') return null;
  
  // Match various phone number formats with or without separators
  const phoneRegex = /(?:\+?\d{1,3}[-.\s]?)?(?:\(?\d{1,4}\)?[-.\s]?)?(?:\d{1,4}[-.\s]?){1,3}\d{1,4}/g;
  const match = text.match(phoneRegex);
  return match ? match[0] : null;
};
